module.exports = __webpack_public_path__ + "static/media/ribbon@3x.db6d6b94.png";